









































import Vue from 'vue';
export default Vue.extend({
  name: 'BannerRight',
  data: () => ({ }),
  props: {
      title: {
          type: String,
          required: true,
      },
      subText: {
          type: String,
          required: true,
      },
      image: {
          type: String,
          required: true,
      },
      actColor: {
          type: String,
          default: 'primary',
      },
      buttons: {
          type: Array,
      },
  },
});
